var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogs"},_vm._l((_vm.items),function(item){return _c('iw-dialog',{key:item.key,attrs:{"item":item},on:{"close":_vm.close}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }